import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const LearnMoreLink = ({ className, url, text }) => {
  const intl = useIntl();

  return (
    <div className={className}>
      <a
        href={url}
        target="_blank"
        className="text-success"
        rel="noreferrer"
      >
        <i className="far fa-book mr-1" />
        {text ? (
          <>{text}</>
        ) : (
          intl.formatMessage({ defaultMessage: 'Learn more' })
        )}
      </a>
    </div>
  );
};

LearnMoreLink.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
};

LearnMoreLink.defaultProps = {
  className: 'mt-4',
  text: null,
};

export default LearnMoreLink;
